import React from "react";
import Spinner from "../../Components/Spinner/Spinner.jsx";

const ApiAuth = () => {
  return (
    <div
      style={{
        display: "flex",
        alignItems: "center",
        justifyContent: "center",
        minHeight: "100vh",
      }}
    >
      <Spinner label="Loading..." />
    </div>
  );
};

export default ApiAuth;
